// src/components/PlanlanmisOdemeModal.js

import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, FormControl, InputLabel, Select, MenuItem, Alert } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { db } from '../../firebase';
import { collection, addDoc, serverTimestamp, Timestamp } from 'firebase/firestore';

const PlanlanmisOdemeModal = ({ isOpen, onClose, customer, finalBalance }) => {
  const [tutar, setTutar] = useState('');
  const [vadeTarihi, setVadeTarihi] = useState(null);
  const [odemeYontemi, setOdemeYontemi] = useState('Nakit');
  const [aciklama, setAciklama] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setTutar('');
      setVadeTarihi(null);
      setOdemeYontemi('Nakit');
      setAciklama('');
    }
  }, [isOpen]);

  const handleSubmit = async () => {
    if (!tutar || !vadeTarihi) {
      alert('Tutar ve Vade Tarihi alanları zorunludur.');
      return;
    }
    if (finalBalance <= 0) {
      alert('Müşterinin mevcut borcu bulunmamaktadır. Borcu olmayan bir müşteri için vadeli tahsilat planlanamaz.');
      return;
    }
    setIsSaving(true);
    try {
      await addDoc(collection(db, "scheduledPayments"), {
        musteriId: customer.id,
        musteriAdSoyad: customer.adSoyad,
        tutar: Number(tutar),
        vadeTarihi: Timestamp.fromDate(vadeTarihi),
        odemeYontemi,
        aciklama,
        durum: 'Bekleniyor',
        eklenmeTarihi: serverTimestamp(),
      });
      alert('Planlanmış tahsilat başarıyla eklendi!');
      setIsSaving(false);
      onClose();
    } catch (error) {
      console.error("Planlanmış ödeme eklenirken hata: ", error);
      alert('Bir hata oluştu.');
      setIsSaving(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Vadeli / Planlanmış Tahsilat Ekle</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          {finalBalance <= 0 && (
            <Alert severity="warning">Bu müşterinin borcu bulunmamaktadır.</Alert>
          )}
          <DatePicker label="Vade Tarihi *" value={vadeTarihi} onChange={setVadeTarihi} />
          <TextField label="Tutar (₺)" type="number" value={tutar} onChange={(e) => setTutar(e.target.value)} required disabled={finalBalance <= 0} />
          <FormControl fullWidth disabled={finalBalance <= 0}><InputLabel>Ödeme Yöntemi</InputLabel><Select value={odemeYontemi} label="Ödeme Yöntemi" onChange={(e) => setOdemeYontemi(e.target.value)}><MenuItem value="Nakit">Nakit</MenuItem><MenuItem value="Kredi Kartı">Kredi Kartı</MenuItem><MenuItem value="Havale/EFT">Havale/EFT</MenuItem></Select></FormControl>
          <TextField label="Açıklama" value={aciklama} onChange={(e) => setAciklama(e.target.value)} multiline rows={2} disabled={finalBalance <= 0} />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: '16px 24px' }}>
        <Button onClick={onClose} disabled={isSaving}>İptal</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={isSaving || finalBalance <= 0}>{isSaving ? 'Kaydediliyor...' : 'Kaydet'}</Button>
      </DialogActions>
    </Dialog>
  );
};
export default PlanlanmisOdemeModal;